(() => {
  const FORM_SELECTOR = 'form[data-type="add-to-cart-form"][data-has-selling-plans="true"]';

  function syncPurchaseOptionState(form) {
    const subscriptionInput = form.querySelector('[data-brunos-purchase-option="subscription"]');
    const planSelect = form.querySelector('[data-brunos-selling-plan-select]');

    if (!subscriptionInput || !planSelect) return;

    const shouldSubscribe = subscriptionInput.checked;
    planSelect.disabled = !shouldSubscribe;

    if (shouldSubscribe) {
      planSelect.setAttribute('name', 'selling_plan');
      if (!planSelect.value && form.dataset.firstSellingPlanId) {
        planSelect.value = form.dataset.firstSellingPlanId;
      }
      return;
    }

    planSelect.removeAttribute('name');
  }

  function initSubscriptionForms(root = document) {
    root.querySelectorAll(FORM_SELECTOR).forEach((form) => {
      if (form.dataset.brunosPurchaseInit === 'true') return;
      form.dataset.brunosPurchaseInit = 'true';

      const purchaseOptions = form.querySelectorAll('[data-brunos-purchase-option]');
      if (!purchaseOptions.length) return;

      purchaseOptions.forEach((option) => {
        option.addEventListener('change', () => syncPurchaseOptionState(form));
      });

      syncPurchaseOptionState(form);
    });
  }

  document.addEventListener('DOMContentLoaded', () => initSubscriptionForms());
  document.addEventListener('shopify:section:load', (event) => initSubscriptionForms(event.target));
})();
